import { v4 as uuid } from "uuid";

export const repeat = <T>(val: T, times: number): T[] => {
	if (times <= 0) return [];
	const repeated: T[] = [];
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	for (const _once of Array(times)) {
		repeated.push(val);
	}
	return repeated;
};

export const uniqueId = uuid;

export const arr = <T>(size: number, value?: T) => {
	return repeat<T>(value!, size);
};

export {};
